import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/blog/autor_icon.svg")